<template>
  <div class="text botter-conversation botter-datetime-picker">
    <div class="d-flex align-end " :class="getAlignment()">
      <user-chat-image :sender="con.sender" v-if="con.sender.sender_type === 'BOT'"/>
      <div class="full-width">
        <div  class="botter-text" :class="getColor()" v-if="con.payload">
          <p v-html="con.payload">
          </p>
        </div>
        <v-menu
          v-model="menu2"
          ref="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              readonly
              v-if="!disabled"
              disabled
              class="mt-3"
              color="primary"
              v-bind="attrs"
              block
              v-on="on"
            >{{con.buttonTitle}}{{date}}</v-btn>
          </template>
          <v-time-picker
            v-model="date"
            full-width
            v-if="con.hasTime"
            @click:minute="postBack(date)"
            color="primary"
          ></v-time-picker>
          <v-date-picker v-model="date"  color="primary" v-else @input="postBack(date)"></v-date-picker>
        </v-menu>
      </div>
    </div>
    <div class="chat-date d-flex" :class="getAlignment()">{{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('MMMM Do YYYY')}} {{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('h:mm a')}}</div>
  </div>
</template>

<script>
  import userChatImage from "./common/userChatImage";
  import common from "../../../../utils/common";
  export default {
    name: "travelData",
    components: {
      userChatImage
    },
    props: {
      con: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      index: {
        type: Number,
        default: ()=> {
          return 0
        }
      }
    },
    data() {
      return {
        common,
        lastMessageGroup: true,
        date: '',
        time: '',
        menu2: '',
        disabled: false
      }
    },
    mounted() {
      this.$store.dispatch('setInputDisabled',true)
    },
    methods: {
      getAlignment() {
        if (this.con.type==='user') {
          return 'justify-end'
        } else if(this.con.type==='bot') {
          return 'justify-start'
        }
      },
      getColor() {
        if (this.con.type==='user') {
          return 'botter-user-text'
        } else if(this.con.type==='bot') {
          return 'botter-bot-text'
        }
      },
      postBack (value) {
        this.menu2 = false
        this.$emit('postText',value)
        this.disabled = true
        this.$store.dispatch('pushMessage', {
          slug: 'text',
          payload: value,
          type: 'user',
          lastMessageGroup: true
        })
        this.$store.dispatch('setInputDisabled',false)
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss">
.botter-datetime-picker {
  .v-picker {
    margin: 5px;
    background-color: #EAF0F7 !important;
    .v-picker__body {
      background-color: #EAF0F7 !important;
    }
  }
}

</style>
